import React from 'react'
import styles from './index.less'

function NoEdit({ children }) {
    return <div className={styles.noEdit}>{children}</div>
}

export default NoEdit
